import { parseJSONData, propertyInterestDataSchema } from '@aikoa/common'
import { useTranslations } from '@aikoa/i18n/react'
import { useState } from 'react'
import { View } from 'react-native'
import { InterestFlowBottomSheet } from '~/components/interests/InterestFlowBottomSheet'
import { ToggleableInterestDisplay } from '~/components/interests/ToggleableInterestDisplay'
import type { LeadDetail } from '~/components/leads/types'
import { Label } from '~/components/typography/Content'
import { cn } from '~/lib/utils'

type LeadInterestsProps = {
  className?: string
  valueClassName?: string
  lead: LeadDetail
}

export function LeadInterests({ className, valueClassName, lead }: LeadInterestsProps) {
  const { t } = useTranslations('leads')
  const interest = lead.interests?.[0]
  const interestData = parseJSONData(interest.data, propertyInterestDataSchema)

  const [isInterestFlowOpen, setInterestFlowOpen] = useState(false)

  if (!interestData) {
    return (
      <View className={cn('rounded-xl bg-background px-6 py-4', className)}>
        <Label className="text-center text-secondary">{t(($) => $.detail.noInterest)}</Label>
      </View>
    )
  }

  return (
    <View className="gap-2">
      {lead.ownedContactId && (
        <InterestFlowBottomSheet
          isOpen={isInterestFlowOpen}
          onOpenChange={setInterestFlowOpen}
          contactId={lead.ownedContactId}
          allowNew={false}
          showInterestDetails={false}
        />
      )}
      <ToggleableInterestDisplay
        interest={interestData}
        defaultDetailed
        valueClassName={valueClassName}
        className={cn('gap-3 border-none px-5 group-aria-expanded/interest:px-0', className)}
      />
    </View>
  )
}
